import * as React from 'react'
import * as st from './scoutBanner.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { Container, Link, Text, Spacing } from 'DVWebNodeUI'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'

export interface IScoutBannerProps {
  content?: WpsRuntime.atv.wps.ScoutBannerModelProps
}

export const ScoutBannerComp = ({ content }: IScoutBannerProps) =>
  content ? (
    <Container className={`${stUtility.pageSection} ${st.scoutBanner}`}>
      <h2 className={Spacing.base}><Text string={content.discover}/></h2>
      <div className={st.scoutBannerBody} >
        <div className={st.scoutBannerBodyContents} >
          <h2><strong><Text string={content.newBadge}/></strong><Text string={content.header}/></h2>
          <Link href={content.pageLink}>
            <div><Text string={content.body}/></div>
            <div className={st.scoutTryNow}><Text string={content.tryNow}/></div>
          </Link>
        </div>
      </div>
    </Container>) : null

export const ScoutBanner = ScoutBannerComp
